// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"e82637c8","120":"e82637c8","122":"338003fb","198":"864ecbab","321":"864ecbab","342":"3123d233","385":"864ecbab","386":"ae6eaa1b","497":"69acbf8a","652":"b12616b2","810":"e82637c8"}[chunkId] + ".chunk.css";
};